































import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useRevokeApiKey } from '@/store/modules/apiKeys';
import { ApiKey } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	props: {
		apiKey: {
			type: Object as () => ApiKey,
			required: true,
		},
	},
	emits: ['revoke'],
	setup(props, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const { revokeApiKey, clearError, isLoading, hasError, error: revokeError } = useRevokeApiKey(root.$store);

		const error = computed<string>(
			() =>
				revokeError.value?.response?.data?.message ||
				'An error occurred while attempting to revoke the API key. Please try again.'
		);

		const handleConfirmRevoke = async () => {
			clearError();

			const success = await revokeApiKey(props.apiKey.id);

			if (success) {
				root.$store.dispatch('users/getUsers');
				showConfirmationDialog.value = false;
			}
		};

		return {
			showConfirmationDialog,
			isLoading,
			hasError,
			error,
			clearError,
			handleConfirmRevoke,
		};
	},
});
